import { TaskTemplate } from "../types";
import appClient from "../../common/services/AppClient";
import { UserModel } from "../../tasks/types";
import { endpoints } from "../../../config";

export default class TaskTemplateService {
    getTaskTemplates(projectId?: string) {
        let url = endpoints.tasksUrl + "tasktemplates";
        if (projectId) {
            url += "/" + projectId;
        }
        return appClient.get<TaskTemplate[]>(url);
    }

    getAccessibleTaskTemplates() {
        const url = endpoints.tasksUrl + "tasktemplates/user";
        return appClient.get<TaskTemplate[]>(url);
    }

    createTaskTemplate(formData: FormData) {
        const url = endpoints.tasksUrl + "tasktemplates/new";
        return appClient.post(url, formData);
    }

    updateTaskTemplate(formData: FormData, templateId: string) {
        const payload = { templateId, ...formData };

        const url = endpoints.tasksUrl + "tasktemplates/update";
        return appClient.patch(url, payload);
    }

    deleteTaskType(templateId: string) {
        const url = endpoints.tasksUrl + `tasktemplates/delete/${templateId}`;
        return appClient.delete(url);
    }

    getUsersInProject(projectId: string) {
        const url =
            endpoints.tasksUrl +
            `users/project/${projectId}?includeRoles=false`;
        return appClient.get<UserModel[]>(url);
    }
}
